import React, { useEffect } from "react";
import L from "leaflet";
import { Marker, useMap, useMapEvents } from "react-leaflet";

const locationIcon = L.icon({
  iconUrl: "/assets/icons/location-pin.svg",
  iconSize: [32, 40],
  iconAnchor: [16, 40],
  popupAnchor: [0, -40],
});

export const DraggableMarker = ({ position, setPosition }) => {
  return (
    <Marker
      icon={locationIcon}
      draggable
      position={position}
      eventHandlers={{
        dragend: (e) => {
          const marker = e.target;
          const { lat, lng } = marker.getLatLng();

          setPosition({
            lat,
            lng,
          });
        },
      }}
    />
  );
};

export const MapEvents = ({ setPosition }) => {
  useMapEvents({
    click(e) {
      setPosition({
        lat: e.latlng.lat,
        lng: e.latlng.lng,
      });
    },
  });

  return null;
};

export const RecenterMap = ({ lat, lng }) => {
  const map = useMap();

  useEffect(() => {
    map.setView([lat, lng], 16);
  }, [lat, lng, map]);

  return null;
};
